import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardHeader, MDBCardBody, MDBCardText, MDBAnimation } from 'mdb-react-ui-kit'
import { } from 'mdb-react-ui-kit'
import React, { useState } from 'react'
export function VisionMissionValue() {

    const [hoverAnimation, setHoverAnimation] = useState(false);

    const toggleHover = () => {
        setHoverAnimation(!hoverAnimation)
    }

    return (
        <>
            <MDBContainer style={{ backgroundColor: '#1B5E20' }} className={'border border-0 border-danger mb-5 py-5 bg-gradient bg-opacity-100'}>
                <MDBRow center className={'border border-0 border-danger'}>
                    <MDBCol className={'mb-5 mb-lg-0'} lg={2}>
                        <MDBAnimation reset={true} animation={'pulse'} start={'onHover'} duration={500}>
                            <MDBCard className={'shaodow'}>
                                <MDBCardHeader>VISION</MDBCardHeader>
                                <MDBCardBody>
                                    <MDBCardText className={'text-center fw-light'}>
                                        NUS Network Ghana desires a world where agricultural biodiversity is conserved, carefully
                                        utilized and continuously developed; a world where smallholder farmers are enabled to contribute to
                                        and benefit from, biodiversity based resilient food production systems.
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBAnimation>
                    </MDBCol>
                    <MDBCol className={'mb-5 mb-lg-0'} lg={2}>
                        <MDBAnimation reset={true} animation={'pulse'} start={'onHover'} duration={500}>
                            <MDBCard className={'shadow-5 '}>
                                <MDBCardHeader>MISSION</MDBCardHeader>
                                <MDBCardBody>
                                    <MDBCardText className={'text-center fw-light'}>
                                        As a global collaborative network, we are on a mission to transform agriculture to secure a sustainable
                                        future for food, nature and rural communities.
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBAnimation>
                    </MDBCol>
                    <MDBCol className={'mb-5 mb-lg-0'} lg={2}>
                        <MDBAnimation reset={true} animation={'pulse'} start={'onHover'} duration={500}>
                            <MDBCard className={'shadow-5'}>
                                <MDBCardHeader>CORE VALUE</MDBCardHeader>
                                <MDBCardBody>
                                    <MDBCardText className={'text-center fw-light'}>
                                        We are proud to be a member-led organization combining global and local reach. We hold ourselves
                                        accountable for living and delivering our values in all we do. We are transparent, credible, innovative
                                        and we champion continuous improvement. Our services are characterized by their quality, flexibility
                                        and cost-effectiveness.
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBAnimation>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </>
    )
}